/* eslint-disable no-unused-expressions */
import { Text } from "components";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AuthService from "../../Lib/API/Auth";
import { FirstTime } from "./FirstTime";
import { FirstTime_2 } from "./FirstTime_2";
import { FirstTime_3 } from "./FirstTime_3";
import { FirstTime_4 } from "./FirstTime_4";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setLogoImage } from "services/api/organization";
import { getAccessTokenSilently } from "utils/functions";
import Header from "./headSession";
import { Box } from "@material-ui/core";
import bg404 from "assets/images/404.svg";
import { Fonts, FontColors } from "theme/fontConfig";

export const StepsContainer = ({
  stepsArray,
  currentStep,
  setCurrentStepCheck,
}) => {
  return (
    <div className="">
      <div
        className="text-center my-auto"
        style={{ minHeight: 40, paddingTop: 18 }}
      >
        <Text style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: FontColors.Blue2555EF }}>
          User not found, please logout and try again
        </Text>
      </div>
    </div>
  );
};
export const InitialMemberPage = (props) => {
  const dispatch = useDispatch();
  const [origin] = useState(
    JSON.parse(localStorage.getItem("getOrginasitionBySubDomain"))
  );
  const [checkMember, setMember] = useState();
  const history = useHistory();
  localStorage.setItem("subDomain", window.location.host.split(".")[0]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      AuthService.getUserExist(token)
        .then((res) => {
          setMember(res);
          localStorage.setItem(
            "paymentMethod",
            JSON.stringify(res?.user?.paymentMethodCreditCard)
          );
          localStorage.setItem("checkUser", JSON.stringify(res?.exists));
          localStorage.setItem(
            "accountID",
            res?.user?.permissions?.linked_account?._id
          );
          localStorage.setItem(
            "accountName",
            res?.user?.permissions?.linked_account?.family_name
          );
          localStorage.setItem(
            "accountInfo",
            JSON.stringify({
              firstName: res?.user?.permissions?.linked_contact?.first_name,
              lastName: res?.user?.permissions?.linked_contact?.last_name,
              primary_email_address:
                res?.user?.permissions?.linked_contact?.email_address,
              emergency_contact_name:
                res?.user?.permissions?.linked_contact?.emergency_contact_name,
              emergency_contact_number:
                res?.user?.permissions?.linked_contact
                  ?.emergency_contact_number,
              profileImage: res?.user?.permissions?.linked_contact?.profile_img,
            })
          );
          localStorage.setItem(
            "organization",
            JSON.stringify(res?.user?.permissions?.organization)
          );
          localStorage.setItem(
            "memberSetting",
            JSON.stringify(
              res?.user?.permissions?.organization?.memberSetting || {}
            )
          );
          localStorage.setItem(
            "memberPortalDirectory",
            JSON.stringify(
              res?.user?.permissions?.organization?.memberPortalDirectory ||
                false
            )
          );
          localStorage.setItem(
            "orgId",
            res?.user?.permissions?.organization?._id
          );
          localStorage.setItem(
            "linkedAccount",
            JSON.stringify(res?.user?.permissions?.linked_account)
          );
          localStorage.setItem("hasPayment", res?.user?.hasPayment);
          localStorage.setItem(
            "logoImg",
            res?.user?.permissions?.organization?.logoImg
          );
          res?.user?.permissions?.organization?.logoImg &&
            dispatch(
              setLogoImage(res?.user?.permissions?.organization?.logoImg)
            );
          localStorage.setItem(
            "orgName",
            res?.user?.permissions?.organization?.orgName
          );
          document.title = `${res?.user?.permissions?.organization?.orgName}`;
          setLoading(false);
        })
        .catch((err) => {
          // setMember(err.data.exists)
          localStorage.setItem("checkUser", err?.data?.exists);
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAccessTokenSilently, history, checkMember]);

  const [currentStep, setCurrentStep] = useState(1);
  const userId = checkMember?.user?.permissions?.linked_contact;
  localStorage.setItem("userId", userId);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullHebrewName, setFullHebrewName] = useState("");
  const [preferredTitle, setPreferredTitle] = useState("");

  const FistPageDisplay =
    Boolean(checkMember?.user?.permissions?.permissionType) &&
    checkMember?.user?.permissions?.permissionType !== "member"
      ? history.push("/check-valid-user")
      : checkMember?.exists
      ? history.push("/home")
      : FirstTime;

  const stepsArray = [
    {
      stepNumber: 1,
      component: FistPageDisplay,
      package: {
        firstName,
        setFirstName,
        middleName,
        setMiddleName,
        lastName,
        setLastName,
        fullHebrewName,
        setFullHebrewName,
        preferredTitle,
        setPreferredTitle,
      },
    },
    { stepNumber: 2, component: FirstTime_2 },
    { stepNumber: 3, component: FirstTime_3 },
    { stepNumber: 4, component: FirstTime_4 },
  ];
  const setCurrentStepCheck = ({ type }) => {
    if (currentStep < stepsArray.length && type === "next") {
      setCurrentStep(currentStep + 1);
    } else if (currentStep !== 1 && type === "back") {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    if (loading) return;
    if (localStorage.getItem("redirectUrl")) {
      history.push(localStorage.getItem("redirectUrl"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  console.log(loading, "loading");
  if (loading) return <div>Loading...</div>;
  return (
    <div className="first-time">
      <Header origin={origin} />
      <div className="col-sm-7 mx-auto">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: "50px !important",
          }}
        >
          <img
            src={bg404}
            alt="background"
            className="auth-background-image"
            width="50%"
          />
        </Box>
        <StepsContainer
          stepsArray={stepsArray}
          currentStep={currentStep}
          setCurrentStepCheck={setCurrentStepCheck}
        />

        <div class="col-12 mt-2 text-center">
          <h3>
            <span class="mr-1 powered-text"> Powered by </span>
            <span>
              <a href="/">
                <img
                  src="https://easyshul.com/assets/images/logos/Logo.svg"
                  className="powered-logo"
                  alt="powered-logo"
                />
              </a>
            </span>
          </h3>
        </div>
      </div>
    </div>
  );
};
